import {
  setAnimationFrameRequest,
  setCanvasFileName,
  getAnimationFrameRequest,
  getXrwDataFolderName
} from './dataOps';
import {createDeferred} from './deferred';
import {updateGamepadsInfo} from './device';
import {getMainCanvasDOMElement} from './mainCanvasDOM';
import {callComponentMethod, requestToDrawFrame, setServerTime} from './moduleCaller';
import {hel_isMobile, hel_getiOSVersion, hel_isMac, hel_isLangJa, hel_isVRDevice} from './platform';

export const drawFrame = () => {
  updateGamepadsInfo();
  requestToDrawFrame();
  const myReq = window.requestAnimationFrame(drawFrame);
  setAnimationFrameRequest(myReq);
};

export const hel_setCanvasFileName = (canvasFileName: string) => {
  setCanvasFileName(canvasFileName);
};

/**
 * AnimationFrameのループを開始する
 */
export const hel_requestAnimationFrame = () => {
  drawFrame();
};

/**
 * AnimationFrameのループを停止する
 */
export const hel_cancelAnimationFrame = () => {
  const request = getAnimationFrameRequest();
  window.cancelAnimationFrame(request);
};

/**
 * HeliScriptのコンポーネントにおけるコールバック関数 `OnLoaded()` と同じタイミングで完了する。
 *
 * つまりこのPromiseが完了したこの段階では、すでにCanvas層の読み込みも完了している。
 */
export const onLoadedDeferred = createDeferred<void>();

/**
 * シーン側コンポーネント呼び出し
 * @remarks
 * 本関数はグローバル関数用の共通処理であり、それ以外でのTypeScript層内での呼び出しは禁止。代わりに {@link hel_DispatchEvent} を利用する。
 */
export const hel_CallSceneComponent = (
  itemName: string,
  componentName: string,
  methodName: string,
  ...params: any
) => {
  return callComponentMethod(true, itemName, componentName, methodName, params);
};

/**
 * HeliScriptのコンポーネント呼び出し
 * @remarks
 * 本関数はグローバル関数用の共通処理であり、それ以外でのTypeScript層内での呼び出しは禁止。代わりに {@link hel_DispatchEvent} を利用する。
 */
export const hel_CallCanvasComponent = (
  layerName: string,
  componentName: string,
  methodName: string,
  ...params: any
) => {
  return callComponentMethod(false, layerName, componentName, methodName, params);
};

/**
 * サーバー時刻を設定
 */
export const hel_SetServerTime = (datetime: number): void => {
  setServerTime(datetime);
};

/**
 * Common 初期�?
 * @param type
 * @param characterType
 * @param args1
 * @param strArgs0
 * @param canTouch
 * @param isMultiPlay
 * @param isXr
 */
export const requestBootStrapGameEngine = (
  type: number,
  characterType: number,
  args1: number,
  strArgs0: string,
  canTouch: boolean,
  isMultiPlay: boolean,
  isXr: boolean
) => {
  // Moduleが初期化されていない時にccallするとundefinedの例外が発生するので抑制する
  if (HeliModule.calledRun === undefined || !HeliModule.calledRun) return;

  if (HeliModule.ccall === undefined) {
    return;
  }
  const mainCanvas = getMainCanvasDOMElement();
  if (!mainCanvas) {
    throw new Error(`[ requestBootStrapGameEngine ] canvas is not found for target env`);
  }

  HeliModule.ccall(
    'Start',
    null,
    [
      'number', // type
      'number', // w
      'number', // h
      'number', // m
      'number', // iosv
      'number', // mac
      'number', // touch
      'number', // ja
      'number', // ctype
      'number', // args1
      'number', // multi
      'string', // args0
      'string', // name
      'boolean', // vr
      'boolean' // vrdevice
    ],
    [
      type,
      mainCanvas.width,
      mainCanvas.height,
      hel_isMobile() ? 1 : 0,
      hel_getiOSVersion(),
      hel_isMac() ? 1 : 0,
      canTouch ? 1 : 0,
      hel_isLangJa() ? 1 : 0,
      characterType,
      args1,
      isMultiPlay ? 1 : 0,
      strArgs0,
      getXrwDataFolderName(),
      isXr,
      hel_isVRDevice() ? true : false // VRデバイスかどうか
    ],
    {async: true}
  );
};
